import React from 'react'
import './MentionLegales.css'

import {usePage} from "../../Context/PageContext"
import { useQuery } from "react-query";
import fetchPageById from "../../Data/page_service";

export const MentionLegales = () => {
    const {page , setPageAttributes}=usePage()
    useQuery('pageById', () => fetchPageById(setPageAttributes , 'mentions_legales'));


    return (
        <div className="MentionLegales">
         { page && <div dangerouslySetInnerHTML={{ __html: page.contenu}} />}

        </div>
    )
}